<div class="container">
    <div class="title">Access interzis!</div>
    <div class="description">Accesul interzis în cadrul acestui modul.</div>
</div>